<template>
  <div />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import auth from '../mixins/auth';

export default {
  mixins: [auth],
  data() {
    return {
      timer: undefined,
    };
  },
  computed: {
    ...mapGetters('auth', ['isExpired']),
  },
  async created() {
    this.$log.debug('auth created');
    this.$root.$on('auth:logoff', () => {
      this.$log.debug('stopping auth timer');
      clearTimeout(this.timer);
    });
    if (this.isExpired) {
      await this.refreshToken();
    }
    this.setTimer(60000);
  },
  destroyed() {
    this.$root.$off('auth:token');
    this.$root.$off('auth:logoff');
    clearTimeout(this.timer);
  },
  methods: {
    ...mapActions('auth', ['REFRESH_auth']),
    isBeforeToday(date) {
      return new Date(date).valueOf() < new Date().valueOf();
    },
    async refreshToken() {
      this.$log.info('refreshing auth token');
      // refresh token expired
      await this.REFRESH_auth();
      this.$log.info('refreshed auth token');
    },
    setTimer(expires) {
      this.timer = setTimeout(() => this.refreshToken(), expires);
      this.$log.info(`started token refresh timer: ${expires}ms`);
    },
  },
};
</script>
